import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";
import {PowerSelect} from 'react-power-select';

const CustomOptionComponent = ({ option }) => (
    <div>
      <strong>{option.company.short_name}</strong>&nbsp;
      <img
        src={"/user-images/"+option.id}
        className="drivers-powerselect-driver-image"
      />
      <span>{option.first_name} {option.last_name}</span>
    </div>
    );
    
export default class SubcontractorInvoicesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/subcontractor-invoices-report/',
            totalSubcontractedJobs:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Subcontractor Invoices Report',
            isDownloading:false,
            selectedOption:'',
            drivers:[]
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDriverSelection = this.handleDriverSelection.bind(this);
    }
    componentDidMount() {
        this.getDrivers();
    }
    getDrivers() {
        let that = this;
        $.ajax({
          url: "/api/v1/portal/subcontractors/all/for-dropdown-menu",
          data: {api_token: window.api_token},
          cache: false
        })
        .done(function(driversJson) {
          that.setState({ drivers: driversJson});
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleDriverSelection(option) {
        this.setState({subcontractor_id: option.option.driver_id,selectedDriver:option.option.full_name,selectedOption:option.option});
    }
    handleReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD")+'/'+this.state.subcontractor_id;

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({
                totalSubcontractedJobs: response.jobs,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvData(filename,text){
        this.setState({isDownloading: true});
        let filenamed = filename+" "+this.state.selectedDriver+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "JOB,REG,CUSTOMER,STATUS,SUBCONTRACT INVOICE NUMBER,DRIVER/SUBCONTRACTOR COMPLETED DATE\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
    }
    render() {
        let totalSubcontractedJobs = [];
        let downloadCsvData = [];
        if(this.state.totalSubcontractedJobs.length > 0){
            let totalLength =(this.state.totalSubcontractedJobs.length - 1);
            
            this.state.totalSubcontractedJobs.map((job, index) => {
                totalSubcontractedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={"/jobs/view/"+job.id}>{job.id}</a></td>
                        <td>{job.vehicle.registration_number}</td>
                        <td>{job.customer.name}</td> 
                        <td>{job.status}</td> 
                        <td>{job.subcontract_invoice_number}</td> 
                        <td>
                            {(job.driver_completed_at) ?
                                moment(job.driver_completed_at).format("DD.MM.YYYY") :
                                job.driver_completed_at
                            }
                        </td> 
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                    (job.id)+','+
                    job.vehicle.registration_number+','+
                    job.customer.name+','+
                    job.status+','+
                    job.subcontract_invoice_number+','+
                    ((job.driver_completed_at) ?
                        moment(job.driver_completed_at).format("DD.MM.YYYY") :
                        job.driver_completed_at)+','+"\n";
            });
            
        }else{
            totalSubcontractedJobs.push(
               <tr key='no-records'><td colSpan="6" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Subcontractor Invoices Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select From Date:
                    </div>
                    <div className="col-md-2">
                       Select To Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3">
                        <PowerSelect
                            options={this.state.drivers}
                            optionLabelPath="full_name"
                            selected={this.state.selectedOption}
                            onChange={this.handleDriverSelection}
                            placeholder="-- select a Subcontractor -- "
                            optionComponent={<CustomOptionComponent />}
                            required
                            />
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvData(this.state.filename,downloadCsvData)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-10">
                    <h4 className="col-md-3 alert alert-info">{(this.state.totalSubcontractedJobs.length)} jobs found..</h4>
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                   <tr>
                                        <th>Job</th>
                                        <th>REG</th>
                                        <th>Customer</th>
                                        <th>Status</th>
                                        <th>Subcontract Invoice Number</th>
                                        <th>Driver/Subcontractor Completed Date</th>
                                   </tr>
                                </thead> 
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="6"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalSubcontractedJobs}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-subcontractor_invoices_report')) {
    ReactDOM.render(
        <SubcontractorInvoicesReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-subcontractor_invoices_report')
    );
}



